import axios from './axiosBase'
import { coreUrl } from './api'

const PREFIX = '/api'

export async function login(formData) {
  const res = await axios({
    method: 'POST',
    url: `${coreUrl}${PREFIX}/login`,
    data: formData,
    validateStatus: (status) => status >= 200 && status <= 302,
  })

  return res
}

export async function recoverPassword(formData) {
  const res = await axios({
    method: 'POST',
    url: `${coreUrl}${PREFIX}/user/password-recover`,
    data: formData,
  })

  return res
}

export async function verifySignature(signature) {
  const res = await axios({
    method: 'POST',
    url: `${coreUrl}${PREFIX}/signature/validate`,
    data: signature,
  })

  return res
}
